module.exports = __webpack_public_path__ + "img/pagamento-online.414efdbe.png";